import Complement from "../composition/Complement"

export default class ElectricalConnection extends Complement {
    static className = "ElectricalConnection"


    getArticleSummary() {
        const installation = this.getAttributeVariation("installation");
        const control = this.getAttributeVariation("control");
        const watts = this.getTechnicalDataByKey("watts");

        const complementSummary = super.getArticleSummary()
        const summary = {
            ...complementSummary,
            installation: installation ?? null,
            control: control ?? null,
            watts: watts ?? null
        }

        return summary;
    }

    getArticleSummaryVariations() {
        const installations = this.getAttributeVariations("installation");
        const controls = this.getAttributeVariations("control");
        const watts = this.getTechnicalDataByKey("watts");

        const complementSummary = super.getArticleSummaryVariations()
        const summaryVariations = {
            ...complementSummary,
            installations: installations ?? null,
            controls: controls ?? null,
            watts: watts ?? null
        }

        return summaryVariations;
    }

    getInfo() {
        const superComplementInfo = super.getInfo();
        const delivered_power = this.getTechnicalDataByKey("watts")?.value
        const complementInfo = {
            ...superComplementInfo,
            delivered_power,
            article: {
                ...superComplementInfo.article,
                type: "electricalConnection",
            }
        };
        return complementInfo;
    }
}